export const intradayPeriodicity = {
  period: 5,
  interval: "minute"
};

export const hourPeriodicity = {
  /*period: 1,*/
  interval: 1,
  timeUnit: "minute"
};

export const dayPeriodicity = {
  period: 1,
  interval: "day"
};

export const weekPeriodicity = {
  period: 1,
  interval: 1,
  timeUnit: "week"
};

export const monthPeriodicity = {
  period: 1,
  interval: 1,
  timeUnit: "month"
};
